import React, { useState, useEffect } from 'react';
import '../App.css';
import { Link, useNavigate } from 'react-router-dom';
import * as Strings from './strings'
import { Form, FormGroup, Button, Label, Input } from 'reactstrap';
import search from '../assets/search_white.png';
import user from '../assets/user.png';
import MyStorage from './util/storage'
import Api from './api/api'
import MyLoader from './util/loader'
import MyError from './util/error'
import showToast from './util/toast'
import { ToastContainer, toast } from 'react-toastify';
// import ReactExport from "react-export-excel";
// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const Doctors = () => {
  const [verified, setVerified] = useState(0);
  const [unverified, setUnverified] = useState(0);
  const [models, setModels] = useState([]);
  const [tempModels, setTempModels] = useState([]); // array of symbols
  const [keyword, setKeyword] = useState('');
  const [loader, setLoader] = useState(false);

  // load data
  useEffect(() => {
    loadData()
  }, [])

  const loadData = () => {
    setLoader(true)
    Api.getDoctors(
      (doctors) => {
        console.log('doctors: ' + doctors.length);
        let pendingModels = []
        let otherModels = []
        let unver = 0
        let ver = 0
        for (let i = 0; i < doctors.length; i++) {
          const doctor = doctors[i];
          if (doctor.status === 'pending') {
            pendingModels.push(doctor)
          }
          else {
            otherModels.push(doctor)
          }

          if (doctor.status === 'verified' || doctor.status === 'active') {
            ver++
          }
          else {
            unver++
          }
        }
        let models = pendingModels.concat(otherModels)
        setLoader(false)
        setModels(models)
        setUnverified(unver)
        setVerified(ver)
      },
      (error) => {
        setLoader(false)
        showToast('error', error)
      })
  };

  const verifyDoctor = (model) => {
    setLoader(true)
    Api.updateStatus(model.email, 'verified',
      () => {
        setLoader(false)
        const temp = models.map((item) => {
          if (item.email === model.email) {
            return { ...item, status: 'verified' };
          }
          else {
            return item;
          }
        });
        setModels(temp)
        setVerified(verified + 1)
        setUnverified(unverified - 1)
        Api.sendVerifiedEmail(model)
      },
      (error) => {
        setLoader(false)
        showToast('error', error)
      })
  };

  const declineDoctor = (model) => {
    setLoader(true)
    Api.updateStatus(model.email, 'declined',
      () => {
        setLoader(false)
        const temp = models.map((item) => {
          if (item.email === model.email) {
            return { ...item, status: 'declined' };
          }
          else {
            return item;
          }
        });
        setModels(temp)
        setUnverified(unverified + 1)
        setVerified(verified - 1)
      },
      (error) => {
        setLoader(false)
        showToast('error', error)
      })
  };

  const searchUsers = (keyword) => {
    let arr = [...models]
    let arrTemp = [...tempModels]
    if (arrTemp.length == 0) {
      arrTemp = arr
    }

    arr = []

    if (keyword === '') {
      arr = arrTemp
    }
    else {
      arrTemp.find((model) => {
        if (model.email.toLowerCase().includes(keyword.toLowerCase()) || model.name.toLowerCase().includes(keyword.toLowerCase())) {
          arr.push(model);
        }
      });
    }

    setModels(arr)
    setTempModels(arrTemp)
    setKeyword(keyword)
  }

  const exportDoctors = () => {

  }

  const deleteUser = (model) => {
    let flag = window.confirm('Are you sure you want to delete this doctor?')
    if (flag) {
      let id = model.id
      Api.deleteDoctor(model, () => { })
      const newModels = models.filter((item, j) => {
        return item.id !== id; //false will delete
      })
      setModels(newModels)
    }
  }

  return (
    <div className='main'>
      <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
        <div style={{ color: 'blue' }}>
          Doctors ({models.length})
        </div>
      </div>

      <div style={{ display: 'flex', marginBottom:-10, marginTop: 0, alignItems: 'center', justifyContent: 'center' }}>
        <FormGroup
          style={{ width: 400, marginTop:20 }}>
          <Input
            type='email'
            placeholder='Search by email or name...'
            value={keyword}
            onChange={(event) => {
              setKeyword(event.target.value)
            }} />
        </FormGroup>
        <div style={{ backgroundColor: 'black', width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 20, marginLeft: 10 }}>
          <img
            onClick={() => {
              console.log('click');
              searchUsers(keyword)
            }}
            src={search}
            style={{ width: 30, height: 30 }}
            className='icon-btn' />
        </div>
      </div>

      <div style={{ display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center' }}>
        <div
          style={{ borderRadius: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: 150, fontSize: 16, border: '1px solid red', color: 'white' }}>
          <div style={{ color: 'red', fontSize: 20, fontWeight: 'bold' }}>
            {unverified}
          </div>
          <div style={{ color: 'red', fontSize: 12 }}>
            Blocked
          </div>
        </div>
        <div
          style={{ borderRadius: 10, marginLeft: 10, marginRight: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: 150, fontSize: 16, border: '1px solid green', color: 'white' }}>
          <div style={{ color: 'green', fontSize: 20, fontWeight: 'bold' }}>
            {verified}
          </div>
          <div style={{ color: 'green', fontSize: 12 }}>
            Active
          </div>
        </div>
        {/* <ExcelFile>
          <ExcelSheet data={models} name="Doctors">
            <ExcelColumn label="name" value="name" />
            <ExcelColumn label="email" value="email" />
            <ExcelColumn label="phone" value="phone" />
            <ExcelColumn label="gender" value="gender" />
            <ExcelColumn label="certification" value="certification" />
            <ExcelColumn label="credentials" value="credentials" />
            <ExcelColumn label="speciality" value="speciality" />
            <ExcelColumn label="address1" value="address1" />
            <ExcelColumn label="address2" value="address2" />
            <ExcelColumn label="city" value="city" />
            <ExcelColumn label="state" value="state" />
            <ExcelColumn label="zipcode" value="zipcode" />
            <ExcelColumn label="country" value="country" />
            <ExcelColumn label="status" value="status" />
          </ExcelSheet>
        </ExcelFile> */}
      </div>

      <div style={{ marginTop: 10 }}></div>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap', overflow: 'scroll', }}>
        {models.map((model, index) => {
          return (
            <div style={{ display: 'flex', marginRight: 15, marginBottom: 15, backgroundColor: '#fff', padding: 10, borderRadius: 10, width: '45%' }}>
              <div style={{ marginTop: 0, display: 'flex' }}>
                <div style={{}}>
                  {/* <div style={{ fontSize: 16, fontWeight: 'bold', color: 'green' }}>#{index + 1}</div> */}
                  <div style={{ fontSize: 16, display: 'flex' }}><div style={{ fontSize: 16, fontWeight: 'bold', marginRight: 10 }}>Name:</div> {model.name}</div>
                  <div style={{ fontSize: 16, display: 'flex' }}><div style={{ fontSize: 16, fontWeight: 'bold', marginRight: 10 }}>Board Certified:</div> {model.certification}</div>
                  <div style={{ fontSize: 16, display: 'flex' }}><div style={{ fontSize: 16, fontWeight: 'bold', marginRight: 10 }}>Credentials:</div> {model.credentials}</div>
                  <div style={{ fontSize: 16, display: 'flex' }}><div style={{ fontSize: 16, fontWeight: 'bold', marginRight: 10 }}>Speciality:</div> {model.speciality}</div>
                  <div style={{ fontSize: 16, display: 'flex' }}>
                    <div style={{ fontSize: 16, fontWeight: 'bold', marginRight: 10 }}>Email:</div>
                    <button
                      style={{ fontSize: 16, marginTop: -1, color: 'blue', borderWidth: 0, backgroundColor: 'transparent', marginLeft: -6 }}
                      onClick={() => {
                        window.open("mailto:" + model.email);
                      }}>
                      {model.email}
                    </button>
                  </div>
                  <div style={{ fontSize: 16, display: 'flex' }}><div style={{ fontSize: 16, fontWeight: 'bold', marginRight: 10 }}>Phone:</div> {model.phone}</div>
                  <div style={{ fontSize: 16, display: 'flex' }}><div style={{ fontSize: 16, fontWeight: 'bold', marginRight: 10 }}>Sex:</div> {model.gender}</div>
                  <div style={{ fontSize: 16, display: 'flex' }}><div style={{ fontSize: 16, fontWeight: 'bold', marginRight: 10 }}>Address:</div> {model.address1 + ' ' + model.address2 + ', ' + model.city + ', ' + model.country}</div>

                  <div style={{ display: 'flex', fontSize: 16, marginBottom: 10 }}>
                    <div style={{ fontWeight: 'bold' }}>Status:</div>
                    <div style={{ marginLeft: 10, color: model.status === 'pending' ? 'blue' : model.status === 'declined' ? 'red' : 'green' }}>{model.status}</div>
                  </div>

                  <div style={{ display: 'flex' }}>
                    {model.status === 'pending' ? // pending/declined/verified
                      <div style={{ display: 'flex' }}>
                        <Button
                          className='btn-block btn-submit'
                          style={{ width: 100, fontSize: 16, backgroundColor: 'green', color: 'white' }}
                          onClick={() => {
                            console.log('click');
                            verifyDoctor(model)
                          }}>
                          Verify
                        </Button>
                        <Button
                          className='btn-block btn-submit'
                          style={{ marginLeft: 10, width: 100, fontSize: 16, backgroundColor: 'red', color: 'white' }}
                          onClick={() => {
                            console.log('click');
                            declineDoctor(model)
                          }}>
                          Decline
                        </Button>
                      </div>
                      :
                      model.status === 'declined' ?
                        <Button
                          className='btn-block btn-submit'
                          style={{ width: 100, fontSize: 16, backgroundColor: 'green', color: 'white' }}
                          onClick={() => {
                            console.log('click');
                            verifyDoctor(model)
                          }}>
                          Activate
                        </Button>
                        :
                        <Button
                          className='btn-block btn-submit'
                          style={{ width: 100, fontSize: 16, backgroundColor: 'red', color: 'white' }}
                          onClick={() => {
                            console.log('click');
                            declineDoctor(model)
                          }}>
                          Block
                        </Button>
                    }
                    <Button
                      className='btn-block btn-submit'
                      style={{ width: 100, marginLeft: 10, fontSize: 16, backgroundColor: 'black', color: 'white' }}
                      onClick={() => {
                        console.log('click');
                        deleteUser(model)
                      }}>
                      Delete
                    </Button>

                  </div>
                </div>

              </div>

            </div>
          );
        })}
      </div>

      <MyLoader loader={loader} />
      <div>
        <ToastContainer />
      </div>
    </div>
  );
}

export default Doctors;